module.exports = __webpack_public_path__ + "static/media/IMG_4199.fd312134.JPG";